
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";

interface RegistrationStepsProps {
  currentStep: number;
}

const RegistrationSteps: React.FC<RegistrationStepsProps> = ({ currentStep }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="mb-6 md:mb-8">
      <div className="flex items-center justify-between max-w-md mx-auto px-2">
        <div className={`flex flex-col items-center ${currentStep >= 1 ? 'text-cecure-700' : 'text-gray-400'}`}>
          <div className={`flex items-center justify-center h-7 w-7 md:h-8 md:w-8 rounded-full ${currentStep >= 1 ? 'bg-cecure-700 text-white' : 'bg-gray-200 text-gray-600'}`}>
            1
          </div>
          <span className="text-xs md:text-sm mt-1">Info</span>
        </div>
        <div className={`h-1 flex-1 mx-2 md:mx-4 ${currentStep >= 2 ? 'bg-cecure-700' : 'bg-gray-200'}`}></div>
        
        <div className={`flex flex-col items-center ${currentStep >= 2 ? 'text-cecure-700' : 'text-gray-400'}`}>
          <div className={`flex items-center justify-center h-7 w-7 md:h-8 md:w-8 rounded-full ${currentStep >= 2 ? 'bg-cecure-700 text-white' : 'bg-gray-200 text-gray-600'}`}>
            2
          </div>
          <span className="text-xs md:text-sm mt-1">Payment</span>
        </div>
        <div className={`h-1 flex-1 mx-2 md:mx-4 ${currentStep >= 3 ? 'bg-cecure-700' : 'bg-gray-200'}`}></div>
        
        <div className={`flex flex-col items-center ${currentStep >= 3 ? 'text-cecure-700' : 'text-gray-400'}`}>
          <div className={`flex items-center justify-center h-7 w-7 md:h-8 md:w-8 rounded-full ${currentStep >= 3 ? 'bg-cecure-700 text-white' : 'bg-gray-200 text-gray-600'}`}>
            3
          </div>
          <span className="text-xs md:text-sm mt-1">Confirm</span>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSteps;
